import
  React
from 'react';

import
  styled
from 'styled-components';

import {
  useHistory,
  useLocation
} from 'react-router-dom';

import {
  HContainer,
  JourneyProvider,
  Text,
  VContainer,
  VContainerVH,
  VFillContainer
} from '@vodacom/web-common';

import {
  SearchProvider
} from '../providers';

import {
  ActionCardList
} from 'components';

import {
  SearchBar
} from '../components';

import {
  CacheKeys,
  CustomColors,
  ErrorKeys,
  OriginContexts,
  SearchRegEx
} from '../../../constants';

import {
  HandleRender
} from 'hocs';

import {
  handleUtagLinkEvent,
  isEqual,
  useRedirectHandler
} from 'helpers';

const Container = styled(HContainer)`
  ${props => props.borderTop && ` border-top: ${props.borderTop};`}
`;

export const Search = props => {

  const [
    state,
    setState
  ] = React.useState({
    searchResults: null,
    searchTerm: '',
    loading: false,
    error: null,
    errorMessage: ''
  });

  const context = JourneyProvider.get(CacheKeys.ConfigContext, 'value');

  const history = useHistory();
  const location = useLocation();

  const mountedRef = React.useRef(true);
  const redirectHandler = useRedirectHandler();

  const getSearchResults = async searchTerm => {

    setState(prevState => ({
      ...prevState,
      loading: true
    }));

    if (!SearchRegEx.test(searchTerm)) {
      setState(prevState => ({
        ...prevState,
        loading: false,
        error: 'Invalid characters',
        errorMessage: 'Invalid characters were entered'
      }));
      return;
    }

    const response = await SearchProvider.getSearchResults(searchTerm);

    if (!mountedRef.current) {
      return;
    }

    if (!response || !response.ok || !response?.result) {

      let errorMessage = 'Something went wrong!';

      if (response.code === 404) {
        errorMessage = 'No results found for search term.';
      }

      setState(prevState => ({
        ...prevState,
        loading: false,
        error: response.error,
        searchResults: null,
        errorMessage: errorMessage
      }));
      return;
    }

    setState(prevState => ({
      ...prevState,
      loading: false,
      error: false,
      searchResults: response.result
    }));
  };

  const onResultClick = () => {

    handleUtagLinkEvent({
      search: state.searchResults?.wikiUrl
    });

    redirectHandler(
      history.location,
      `/redirect?targetUrl=${encodeURIComponent(state.searchResults?.wikiUrl)}&isZeroRated=false`,
      false
    );
  };

  React.useEffect(() => {

    const urlParams = new URLSearchParams(location?.search);
    const term = urlParams.get('term');
    mountedRef.current = true;

    if (term?.length > 0) {

      setState(prevState => ({
        ...prevState,
        searchTerm: term
      }));
      getSearchResults(term);
    }

    return () => {
      mountedRef.current = false;
    };

  }, [ location ]);

  const SearchPage = () => {

    return (

      <VFillContainer>

        <VContainerVH
          padding='9px 7px'
          margin='0 0 16px'
          boxShadow={`0px 5px 15px 0px ${CustomColors.TransparentBlack1}`}
          borderRadius={'4px'}>

          <SearchBar
            value={state.searchTerm}
            onSearchClick={value => {

              if (value?.length > 0) {

                handleUtagLinkEvent({
                  search:'search_apply',
                  search_term: value,
                  page_tool_name: 'search component',
                  page_tool_event: 'use',
                  page_section: 'search'
                });

                history.push(`/search?term=${value}`);
              }
            }} />

        </VContainerVH>

        <HandleRender
          isLoading={state.loading}
          isError={state.error}
          error={{ type: ErrorKeys.Search, title: state.errorMessage }}>

          {
            (state.searchResults?.title || state.searchResults?.links?.length > 0) ?

              <>

                { state.searchResults?.title && state.searchResults?.summary &&

                  <VContainer
                    backgroundColor={CustomColors.White}
                    boxShadow={`0px 5px 15px 0px ${CustomColors.TransparentBlack1}`}
                    padding={'16px 23px'}
                    margin={'0 7px 32px'}
                    onClick={onResultClick}>

                    <Text
                      color={CustomColors.Grey11}
                      fontWeight={'bold'}
                      fontSize={'20px'}
                      padding={'0 0 10px'}>

                      {'Did you know?'}
                    </Text>

                    <Text
                      color={CustomColors.Grey9}
                      fontSize={'16px'}
                      padding={'0 0 10px'}>

                      {state.searchResults?.summary}
                    </Text>

                    { !isEqual(context, OriginContexts.VodaPay) &&

                      <HContainer>

                        <Text
                          color={CustomColors.Grey9}
                          fontSize={'12px'}
                          textDecoration={'underline'}
                          dangerouslySetInnerHTML={
                            { __html: state.searchResults?.title }
                          } />

                        <Text
                          color={CustomColors.Grey9}
                          fontSize={'12px'}
                          textDecoration={'underline'}>
                          {', Wikipedia'}
                        </Text>
                      </HContainer>
                    }

                  </VContainer>
                }

                <VContainer
                  backgroundColor={CustomColors.Grey2}
                  padding={'0 16px'}>

                  <ActionCardList
                    title={'See also'}
                    backgroundColor={CustomColors.Grey2}
                    textFontSize={'16px'}
                    textFontWeight={'bold'}
                    headerPadding={'25px 0 7px'}
                    cardPadding={'25px 20px 25px 0'}
                    fallbackComponent={
                      <Container
                        padding={'25px 0'}>

                        <Text
                          color={CustomColors.Grey9}
                          fontSize={'16px'}
                          fontWeight={'bold'}
                          padding={'0 20px 0 0'}>

                          {'No similar results'}
                        </Text>

                      </Container>
                    }
                    items={state.searchResults?.links?.map((val) => {
                      return {
                        text: val.label,
                        onClick: () => history.push(`/search?term=${val.label}`)
                      };
                    })?.slice(1)}/>

                  </VContainer>

              </>
            : <></>
          }
        </HandleRender>
      </VFillContainer>
    );
  };

  return <SearchPage/>;
};